import React from 'react';
import { FiMenu, FiBell, FiSearch, FiLogOut } from 'react-icons/fi';
import AuthService from '../services/AuthService';

const Header = ({ toggleSidebar }) => {
  const user = AuthService.getCurrentUser() || { name: { first: 'Organizer', last: 'User' }, email: 'picvot.contact@gmail.com' };
  const displayName = typeof user.name === 'object' ? `${user.name?.first || ''} ${user.name?.last || ''}`.trim() : (user.name || 'Organizer User');

  return (
    <header className="h-16 border-b border-slate-200 bg-white px-6 flex items-center justify-between shrink-0 z-30 shadow-sm">
      <div className="flex items-center gap-4">
        <button
          onClick={toggleSidebar}
          className="p-2 rounded-xl bg-slate-100 text-slate-700 hover:text-slate-900 hover:bg-slate-200 transition-all md:hidden"
        >
          <FiMenu className="w-5 h-5" />
        </button>

        <div className="relative hidden sm:block w-72">
          <input
            type="text"
            placeholder="Search events, tickets, attendees..."
            className="w-full bg-slate-50 border border-slate-200 rounded-xl py-2 pl-9 pr-4 text-xs text-slate-900 placeholder-slate-400 outline-none focus:border-purple-600 focus:bg-white transition-colors"
          />
          <FiSearch className="absolute left-3 top-2.5 text-slate-400 w-3.5 h-3.5" />
        </div>
      </div>

      <div className="flex items-center gap-4">
        <button className="relative p-2 rounded-xl bg-slate-50 border border-slate-200 text-slate-600 hover:text-slate-900 hover:bg-slate-100 transition-colors">
          <FiBell className="w-4 h-4" />
          <span className="absolute top-1.5 right-1.5 w-2 h-2 rounded-full bg-purple-600" />
        </button>

        <div className="flex items-center gap-3 pl-2 border-l border-slate-200">
          <div className="w-9 h-9 rounded-xl bg-purple-700 flex items-center justify-center text-white font-bold text-xs uppercase shadow-sm">
            {displayName.charAt(0)}
          </div>
          <div className="hidden lg:block text-left">
            <h4 className="text-xs font-bold text-slate-900 leading-tight">{displayName}</h4>
            <span className="text-[10px] text-slate-500 block font-mono">{user.email || 'partner@tapcoe.com'}</span>
          </div>
          <button
            onClick={() => AuthService.logout()}
            title="Logout"
            className="p-2 text-slate-400 hover:text-red-600 transition-colors ml-1"
          >
            <FiLogOut className="w-4 h-4" />
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
